import type { RosterImportRow } from '@chemoflow/contracts';

/** 引用符・改行を含むCSVを読む。院内システムの出力を想定する。 */
export function parseCSV(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let cur = '';
  let quoted = false;

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (quoted) {
      if (ch === '"' && text[i + 1] === '"') {
        cur += '"';
        i++;
      } else if (ch === '"') quoted = false;
      else cur += ch;
    } else if (ch === '"') quoted = true;
    else if (ch === ',') {
      row.push(cur);
      cur = '';
    } else if (ch === '\n' || ch === '\r') {
      if (ch === '\r' && text[i + 1] === '\n') i++;
      row.push(cur);
      rows.push(row);
      row = [];
      cur = '';
    } else cur += ch;
  }
  if (cur || row.length) {
    row.push(cur);
    rows.push(row);
  }
  return rows.filter((r) => r.some((c) => c.trim()));
}

/** UTF-8 で読めなければ Shift_JIS で読み直す。 */
export function decodeCsv(buffer: ArrayBuffer): string {
  const utf8 = new TextDecoder('utf-8').decode(buffer);
  if (!utf8.includes('�')) return utf8.replace(/^﻿/, '');
  return new TextDecoder('shift_jis').decode(buffer).replace(/^﻿/, '');
}

/** 列：患者ID, 氏名, 診療科, 年齢, 性別, 生年月日, Rp数 */
export function toRosterRows(rows: string[][]): RosterImportRow[] {
  const body = rows.length && !/^\d/.test(rows[0]?.[0] ?? '') ? rows.slice(1) : rows;
  return body
    .map((r) => ({
      patientId: (r[0] ?? '').trim(),
      name: (r[1] ?? '').trim(),
      dept: (r[2] ?? '').trim(),
      age: Number(r[3]) || null,
      sex: (r[4] ?? '').trim(),
      birth: (r[5] ?? '').trim(),
      rpCount: Number(r[6]) || 1,
    }))
    .filter((p) => p.patientId && p.name);
}
